import { DeviceIcon, FavouriteIcon, NavigationIcon } from '@tymbe/ui-icons';
import { useState } from 'react';
import Modal from 'react-modal';
import Options from './components/Options';
import { DropDownMenuOption } from './components/ShiftDetail/DropDownMenu';
import { CrossIcon } from '@tymbe/ty-components/icons';
import { ShiftDetailHistory } from './components/ShiftDetailHistory/ShiftDetailHistory';
import ShiftAttendancePage from './shiftAttendance.page';
import useSearchString from '../../hooks/UrlParamsHandler/useSearchParams';
import moment from 'moment';
import { useShift } from '../../hooks/useShift';

type CalendarPageSidebarModalProps = {
  shiftRequestRefetch: () => Promise<unknown>;
};

export const CalendarPageSidebarModal = ({
  shiftRequestRefetch,
}: CalendarPageSidebarModalProps) => {
  const [searchParams, setSearchParams] = useSearchString();
  const [showHistory, setShowHistory] = useState(false);
  const shiftAttendanceId = searchParams.get('shiftAttendance') || undefined;
  const { data: shift } = useShift(shiftAttendanceId);
  const toggleShowHistory = () => {
    setShowHistory((prev) => !prev);
  };

  const menuOptions: DropDownMenuOption[] = [
    {
      text: 'Upravit směnu',
      icon: (
        <FavouriteIcon name="mode_edit" className="text-secondary-400 size-4" />
      ),
      link: `/shift/${shiftAttendanceId}`,
    },
    {
      text: 'Historie',
      icon: (
        <FavouriteIcon
          name="watch_later"
          className="text-secondary-400 size-4"
        />
      ),
      onClick: () => {
        toggleShowHistory();
      },
    },
  ];

  const onShiftAttendanceClose = () => {
    setShowHistory(false);
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('shiftAttendance');
    setSearchParams(newParams);
  };

  const shiftId = searchParams.get('shiftAttendance') || undefined;

  return (
    <Modal
      isOpen={!!shiftAttendanceId}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={false}
      className="fixed top-4 right-4 bottom-4 left-4 bg-bg rounded-lg drop-shadow-lg z-50 flex flex-col"
      overlayClassName="bg-overlay fixed inset-0 z-modal"
      onRequestClose={onShiftAttendanceClose}
    >
      <div className="text-secondary-600 text-heading-4-xl p-6 flex align-center border-b border-secondary-100 relative">
        {showHistory ? (
          <>
            <NavigationIcon
              name="west"
              onClick={toggleShowHistory}
              className="mr-2 size-5 cursor-pointer"
            />
            Historie
          </>
        ) : (
          <div className="flex flex-col">
            <div className="flex gap-2">
              <div>Detail směny</div>
              <Options
                menuOptions={menuOptions}
                dropDownMenuClassName="left-[255px]"
                className="text-secondary-400"
              />
            </div>

            <div className="flex text-caption-md gap-2 mt-2">
              <div className="flex items-center border-secondary-transparent-10 border-[1px] px-2 py-1 gap-2 rounded-md">
                <FavouriteIcon
                  name="calendar_today"
                  className="w-[16px] h-[16px]"
                />
                {moment(shift?.start_time).format('DD.MM.YYYY')}
              </div>
              <div className="flex items-center border-secondary-transparent-10 border-[1px] px-2 py-1 gap-2 rounded-md">
                <DeviceIcon name="access_time" className="w-[16px] h-[16px]" />
                {moment(shift?.start_time).format('HH:mm')}-
                {moment(shift?.end_time).format('HH:mm')}
              </div>
            </div>
          </div>
        )}

        <CrossIcon
          onClick={onShiftAttendanceClose}
          className="cursor-pointer ml-auto"
        />
      </div>
      {showHistory && shiftId ? (
        <div className="p-5 overflow-auto">
          <ShiftDetailHistory shiftId={shiftId} />
        </div>
      ) : (
        <ShiftAttendancePage onSuccessCallback={shiftRequestRefetch} />
      )}
    </Modal>
  );
};
